const getSectorColor = (status) => {
  switch (status) {
    case 'generic':
      return '#00d8b6'
    case 'free_bet':
      return '#d4445e'
    case 'promo_code':
      return '#048ffa'
    case 're_spin':
      return '#ffb017'
    case 'promo_code_unique':
      return '#c517ff'
    default:
      return '#cccccc'
  }
}

export { getSectorColor }
